export default __webpack_public_path__ + "static/media/paymentsuccess.c8ede06c.png";